import { render, staticRenderFns } from "./financeiro-garantia-minima-global.vue?vue&type=template&id=37dfded9&scoped=true"
import script from "./financeiro-garantia-minima-global.vue?vue&type=script&lang=ts"
export * from "./financeiro-garantia-minima-global.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfded9",
  null
  
)

export default component.exports